// The search page's canvas colour, in one place. The route layout paints it
// on html/body (what iOS Safari tints its bars from) and as the Android
// theme-color; the page paints it on its own root and, at 78%, on the sticky
// header. One constant, so the four can never drift into a visible seam.
//
// Near-black, not true black. At #000000 an OLED phone switches the pixels off
// and the page read as a hole with a wordmark floating in it. This keeps a
// surface: the search pill (near-black at 72%) sits in it as a well, and the
// grain has something to land on. Solid, with that grain as the only texture
// — a drifting light over it was tried and read as a gradient. Neutral on
// purpose —
// the first cut was stone-900 (#1C1917), and its red shift read as brown on
// a phone. Grey, a few steps above black, reads as black with the lights on.
export const SEARCH_BG = "#0A0A0A"

/** The same canvas at an alpha, for the glass header: `#0A0A0A` → `rgba(10,10,10,a)`. */
export function searchBgAlpha(alpha: number): string {
  const n = parseInt(SEARCH_BG.slice(1), 16)
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${alpha})`
}
